// Launch is Texas-only. While this is false the app never asks for a state
// (case form, client profile, attorney/funder preferences, list filters) and
// uses DEFAULT_STATE instead. Flip to true to bring every state field back.
export const STATE_SELECTION_ENABLED = false;
export const DEFAULT_STATE = "Texas";
export const ADMIN = 0;
export const CLIENT = 1;
export const PROFESSIONAL = 2;
export const ASSISTANT = 3;
export const FUNDER = 4;
export const FIRM = 5

export const TOKEN = "token";
export const DEFAULTAVATAR = "https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/defaultAvatar.png";
export const atto1 = "https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/atto1.jpeg";
export const atto2 = "https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/atto2.jpeg";
export const atto3 = "https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/atto3.jpg";
export const atto4 = "https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/atto4.jpeg";
export const LICENSED = "Licensed Attorney"
export const CLIENTTAB = [
    { 
        "menu":"CASES",
        "link" : "/client/cases",
        "key": "1",
        "menuName" : "cases"
    },
    { 
        "menu":"NOTIFICATIONS",
        "link" : "/client/notification",
        "key": "2",
        "menuName" : "notifications",
        "count" : 0
    }
]
export const PROFESSIONALTAB = [
    { 
        "name":"Cases",
        "link" : "/attorney/casesFeed/availableCases"
    },
    { 
        "name":"Notifications",
        "link" : "/attorney/profNotifications",
        "count" : 0
    }
]
export const ASSISTANTADMINTAB = [
    { 
        "menu":"AWAITING APPROVAL",
        "link" : "/admin/approve",
        'menuName' : "approve",
        "key" : "1",
        "count" : 0
    },
    
    { 
        "menu":"NOTIFICATIONS",
        "menuName": "notifications",
        "key": "2",
        "link" : "/admin/notification"
    },
]
export const ADMINTAB = [
    {
        "menu":"FIRM OUTREACH",
        "link" : "/admin/outreach",
        "menuName" : "outreach",
        "key": "4",
    },
    { 
        "menu":"AWAITING APPROVAL",
        "link" : "/admin/approve",
        'menuName' : "approve",
        "key" : "2",
        "count" : 0
    },
    { 
        "menu":"ANALYTICS",
        "link" : "/admin/analytics",
        "menuName" : "analytics",
        "key": "1",
    },
    { 
        "menu":"NOTIFICATIONS",
        "menuName": "notifications",
        "key": "3",
        "link" : "/admin/notification"
    },
]
export const MOBILEADMINTAB = [
    {
        "menu":"OUTREACH",
        "link" : "/admin/outreach",
        "menuName" : "outreach",
        "key": "4",
    },
     { 
        "menu":"ANALYTICS",
        "link" : "/admin/analytics",
        "menuName" : "analytics",
        "key": "1",
    },
    { 
        "menu":"APPROVALS",
        "link" : "/admin/approve",
        'menuName' : "approve",
        "key" : "2",
        "count" : 0
    }
];
export const ANALYTICSCASEHORIZONTALTAB = [
    { 
        "name":"Cases Analyitcs",
        "link" : "/admin/analytics"
    },
        
    { 
        "name":"Cases List",
        "link" : "/admin/notification"
    },
]
export const ANALYTICSPROFHORIZONTALTAB = [
    { 
        "name":"User Analyitcs",
        "link" : "/admin/analytics"
    },
        
    { 
        "name":"User List",
        "link" : "/admin/notification"
    },
]
export const ANALYTICSCLIENTHORIZONTALTAB = [
    { 
        "name":"Client Analyitcs",
        "link" : "/admin/analytics"
    },
        
    { 
        "name":"Client List",
        "link" : "/admin/notification"
    },
]
export const ORGAPPROVELIST = 
[
    "firstName",
    "lastName" ,
    "email",
    "legalType",
    "company",
    "lawFirmLink",
    "phoneNumber",
    "experience",
    "linkedin",
    "casePref",
    "statePref"
];
export const APPROVELIST = 
[
    "firstName",
    "lastName" ,
    "email",
    "legalType",
    "company",
    "lawFirmLink"
];
export const FIRMAPPROVELIST = 
[
    "firstName",
    "lastName" ,
    "email",
    "company",
    "lawFirmLink",
    "phoneNumber",
    "lawFirmId",
]
export const FUNDERAPPROVELIST =
[
    "firstName",
    "lastName" ,
    "email",
    "legalType",
    "company",
    "lawFirmLink",
]
export const ATTORNEYLIST =
[
    "firstName",
    "lastName" ,
    "email",
    "lawFirmLink",
    "linkedin"
];
export const UNAPPROVELIST = 
[   
    "phoneNumber",
    "experience",
    "linkedin"
];
export const profCasesPanelItems = [
    
    {
        "menu" : "AVAILABLE CASES",
        "key" : "1",
        "link" : "/attorney/casesFeed/availableCases",
        "menuName" : "availableCases"

    },
    {
        "menu" : "ACTIVE CASES",
        "key" : "2",
        "link" : "/attorney/casesFeed/activeCases",
        "menuName" : "activeCases",
        "activecount" : 0

    },
    {
        "menu" : "CLOSED CASES",
        "key" : "3",
        "link" : "/attorney/casesFeed/closedCases",
        "menuName" : "closedCases",
        "closedCount": 0
    }
    
];
// Team-up (attorney <-> funder) isn't released yet - only law firms and clients are live.
// Set to true to bring back the menu item, the case-page sections and the dashboard.
// Also hides the AI "litigation funder suitability" rating everywhere (cards, case
// page, AI insights, filters) since it only matters once funders are live.
export const TEAMUP_ENABLED = false;
export const premiumProfCasesPanelItems = [
    ...profCasesPanelItems,
    {
        "menu": "TEAMUP",
        "key" : "4",
        "link" : "/attorney/dashboard",
        "menuName" : "dashboard",
        "count" : 0,
        // only law firms and clients are live for now - shown with a "Soon" tag, not clickable
        "comingSoon" : !TEAMUP_ENABLED
    }
];
export const profCasesPanelItemsOnAsst = 
[
    {
        "menu": "ATTORNEY'S AVAILABLE CASES",
        "key": "1",
         "link" : "/attorney/casesFeed/attAvailableCases",
        "menuName" : "attAvailableCases"
    },
    {
        "menu": "ATTORNEY'S ACTIVE CASES",
        "key": "2",
         "link" : "/attorney/casesFeed/attActiveCases",
        "menuName" : "attActiveCases"
    },
    {
        "menu": "ATTORNEY'S CLOSED CASES",
        "key": "3",
        "link" : "/attorney/casesFeed/attClosedCases",
        "menuName" : "attClosedCases"
    },
    {
        "menu": "ATTORNEY'S NOTIFICATIONS",
        "key": "5",
        "count": 0,
        "link" : "/attorney/casesFeed/attNotifications",
        "menuName" : "attNotifications"
    }

];
export const premiumProfCasesPanelItemsOnAsst =
[
    ...profCasesPanelItemsOnAsst,
    {
        "menu": "ATTORNEY'S TEAMUP",
        "key": "6",
        "count": 0,
        "link" : "/attorney/casesFeed/attTeamup",
        "menuName" : "attTeamup",
        "comingSoon" : !TEAMUP_ENABLED
    },
];
     
export const clientCasesPanelItems = [
    {
        "menu" : "My Cases",
    },
    {
        "menu" : "New Case",
    }, 
];
export const profNotifyPanelItems = [
    {
        "menu" : "Unread",
        "name" : "Unread",
        "count" : 0
    },
    {
        "menu" :  "Read",
        "name" : "Read" 
    }, 
];
export const PROFACCOUNTFIELDS = {
    "First Name" : "firstName",
    "Last Name" : "lastName",
    "Email Id"  : "email",
    "Company" : "company",
    "Designation" : "legalType",
    "Law Firm URL" : "lawFirmLink",
}
// const attorneyData = {
//     "Name" : "attorney?.firstName+" "+"attorney?.lastName,
//     "Email Id"  : "attorney?.email,
//     "Lawfirm Link" : "attorney?.lawFirmLink ? userDetails.attorney?.lawFirmLink :  "nil",
//     "Linked in" : "attorney?.linkedin ? userDetails.attorney?.linkedin :  "nil",
    
// }
export const dateOfIncidentValues = [{
    "id" : '1',
    "name":"Last month",
},
{
    "id" : '6',
    "name": "Last six months",
},
{
    "id" : '12',
    "name": "Last year",
},
{
    "id" : '36',
    "name":"Last three years",
},
{
    "id" : '-36',
    "name":"More than 3 years ago"
} 
];
export const adminCasesPanelItems = [
    {
        "menu" :"To verify",
        "count" : 0,
        key: 0
    },
    {
        "menu" : "Profile updates",
        "count" : 0,
        key : 1
    }, 
    {
        "menu" : "Firm switches",
        "count" : 0,
        key : 2
    }
];

export const adminAnalyticsPanelItems = [
    {
        "menu": "Cases",
        "key" : 0,
        
    },
    {
        "menu": "Professionals",
        "key" : 1,
        
    },
    {
        "menu": "Clients",
        "key" : 2,
        
    },
    {
        "menu" : "Active logins",
        "key" : 3,
    },
    {
        "menu" : "Reports",
        "key" : 4,
    },
    {
        "menu": "Web analytics",
        "key" : 5,
    }
]
export const clientProfilePanelItems = [
    {
        "menu" :"Profile",
        "key" : 0
    },
    {
        "menu" : "Edit Email settings",
        "key" : 2

    },
    {
        "menu" : "Password & security",
        "key" : 1

    },
    {
        "menu" : "Delete Account",
        "key" : 3

    },
   
]
export const unverifiedProfilePanelItems = [
    {
        "menu" :"Profile",
        "key" : 0
    },
    {
        "menu" : "Edit Email settings",
        "key" : 2

    },
    {
        "menu" : "Password & security",
        "key" : 1

    }, 
   
    {
        "menu" : "Delete Account",
        "key" : 3

    },
   
]
//professionals legal 
export const profilePanelItems = [
  
   
    {
        "menu" :"Profile",
        "key" : 0
    },
    {   
        "menu" : "Statistics",
        "key" : 6
    },
    {
        "menu" : "Edit Email settings",
        "key" : 2

    },
    {
        "menu" :"Team management",
        "key" : 4
    },
    {
        "menu" : "Subscription",
        "key" : 7
    },
    {
        "menu" : "Password & security",
        "key" : 1
    }, 
    {
        "menu" : "Changing Law Firm",
        "key" : 5
    },
    {
        "menu" : "Delete Account",
        "key" : 3
    },
   
]
export const firmProfilePanelItems = [
    {
        "menu" :"Profile",
        "key" : 0
    },
    {   
        "menu" : "Statistics",
        "key" : 6
    },
    {
        "menu" : "Edit Email settings",
        "key" : 2

    },
    {
        "menu" : "Subscription",
        "key" : 7
    },
    {
        "menu" : "Password & security",
        "key" : 1

    },
    {
        "menu" : "Delete Account",
        "key" : 3
    },
]
//assistant professionals
export const assistantProfilePanelItems = [
    {
        "menu" :"Profile",
        "key" : 0
    },
    {
        "menu" :"Attorneys",
        "key" : 4
    },
    {
        "menu" : "Edit Email settings",
        "key" : 2

    },
    {
        "menu" : "Password & security",
        "key" : 1

    }, 
    
    {
        "menu" : "Delete Account",
        "key" : 3
    },
];  
export const funderProfilePanelItems = [
    {
        "menu" :"Profile",
        "key" : 0
    },
    {   
        "menu" : "Statistics",
        "key" : 6
    },
    {
        "menu" : "Edit Email settings",
        "key" : 2

    },
    {
        "menu" : "Password & security",
        "key" : 1

    },
    {
        "menu" : "Delete Account",
        "key" : 3
    },
]
export const adminProfilePanelItems = [
    {
        "menu" :"Manage Users",
        "key" : 0
    },
    {
        "menu" : "Edit Email settings",
        "key" : 2

    },
    {
        "menu" : "Password & security",
        "key" : 1

    },
    
]
export const assistantAdminProfilePanelItems = [
    
    {
        "menu" : "Password & security",
        "key" : 0

    },
    {
        "menu" : "Edit Email settings",
        "key" : 2

    },
]
export const initialFilterValue = {
    "caseType": [],
    "incidentState": [],
    "clientState": [],
    "dateOfIncident": [],
    "isClassAction": [],
    "isEntity": [],
    "attAvailable": [],
    "adversePartyPublicCompany": [],
    "defendant": [],
    "aiEstimateUpperValue": [],
    "aiDate": [],
    "aiDifficulty": [],
    "caseCity": [],
    "aiSuitability": []
}
export const premiumFilterDataDisp = [

        {
            "title": "Case Estimate Value",
            "values": [
                {name: "Less than $100,000", id: '{"lowerVal" : "0", "upperVal":"100000"}'},
                {name: "$100,000 to $500,000", id: '{"lowerVal" : "100000", "upperVal":"500000"}'},
                {name: "$500,000 to $1M", id: '{"lowerVal" : "500000", "upperVal":"1000000"}'},
                {name: "$1M to $5M", id: '{"lowerVal" : "1000000", "upperVal":"5000000"}'},
                {name: "$5M to $10M", id: '{"lowerVal" : "5000000", "upperVal":"10000000"}'},
                {name: "More than $10M", id: '{"lowerVal" : "10000000", "upperVal":"100000000"}'} ],
            "name" : "aiEstimateUpperValue",
            'type' : 2,
        },
        {
            "name" : "isClassAction",
            "values" : [{id: "yes", name: "Yes"}, {id: "no", name: "No"}],
            "title" : "Class action",
            'type' : 2,
        },
        {
            "title" : "Against Entity or Individual",
            "values" : [{id: "yes", name: "Entity"}, {id: "no", name: "Individual"}],
            'type' : 2,
            "name" : "isEntity"
        },
        {
            "title" : "Multiple plaintiffs",
            "values" : [{id: "yes", name: "Yes"}, {id: "no", name: "No"}],
            'type' : 2,
            "name" : "defendant"
        },
        {
            "title" : "Deadline to File",
             "values": [
                
                    { name: "Less than 6 Months", id: '{"lowerVal": "0", "upperVal": "180"}' },
                    { name: "Less than 1 Year", id: '{"lowerVal": "0", "upperVal": "365"}' },
                    { name: "Less than 2 Years", id: '{"lowerVal": "0", "upperVal": "730"}' },
                    { name: "More than 2 Years", id: '{"lowerVal": "730", "upperVal": ""}' }
                    
                ],
            "name" : "aiDate",
            'type' : 2,
        },
        {
            "title" : "Difficulty",
            "values" : [
                {name: "Low", id:'{"lowerVal":"1", "upperVal": "6"}'},
                {name: "Medium", id:'{"lowerVal":"7", "upperVal": "8"}'},
                {name: "Hard", id:'{"lowerVal":"9", "upperVal": "10"}'},
            ],
            "name" : "aiDifficulty",
            'type' : 2,
        },
        {
            "title" : "Against Public Company",
            "values" : [
                {name: "Public Company", id: "yes"},
                {name: "Non-Public Company", id: "no"},
                {name: "Unknown", id: "dontKnow"}
            ],
            "name" : "adversePartyPublicCompany",
            'type' : 2,
        },
        ...(TEAMUP_ENABLED ? [{
            "title": "Litigation Funder Suitability",
            "values" : [
                    {name: "Low", id:'{"lowerVal":"1", "upperVal": "4"}'},
                    {name: "Medium", id:'{"lowerVal":"5", "upperVal": "7"}'},
                    {name: "High", id:'{"lowerVal":"8", "upperVal": "10"}'},
                ],
            "name": "aiSuitability",
            'type': 2,
        }] : []),
    ];
 export const GeminiStatus = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  FAILED: 3,
};
export const premiumFilterNames = premiumFilterDataDisp.map(filter => filter.name);
export const stripeProductPaymentLink = 'https://buy.stripe.com/test_dRmbJ2bVgafAcHfekDdjO02';
export const stripeProductPaymentLinkFunder = 'https://buy.stripe.com/5kQeVe1gC73ogXvfoHdjO01';
export const CASETOPROFSTATUS = ["Open", "Requested", "Approved", "Conflict cleared", "Request to close", "Closed case"];
export const numberToString = ["","one",'second','third','fourth', 'fifth','sixth','seventh','eighth','nineth'];

// export const ADMINID = "65b9dda17e2634ee986f04be";
export const DOMAIN = "https://kj6bfl8052.execute-api.us-east-1.amazonaws.com/pdn";
//export const DOMAIN = "http://localhost:8000";



//export const reDirectDomain = "http://localhost:3000";
export const reDirectDomain = "https://www.quickcasereview.com";

export const updateUserProfessionalApi = DOMAIN+"/account/updateUserProfessional";
export const updateUserApi = DOMAIN+"/account/updateUser";
export const seedArrApi = DOMAIN+"/account/seeddbwithcases";
export const getDefaultFilterApi = DOMAIN+"/account/getDefaultFilter";
export const approveUserApi = DOMAIN+"/account/approveUser";
export const approveUserChangeOrgApi = DOMAIN+"/account/approveUserChangeOrg";
export const assistantUsersChangeOrgApi = DOMAIN+"/account/assistantUsersChangeOrg";
export const mailOnceADayApi = DOMAIN+"/auth/mailOnceADay";
export const getNotificationCountApi = DOMAIN+"/auth/getNotificationCount";
export const mailOnceAWeekApi = DOMAIN+"/auth/mailOnceAWeek";
export const raiseNotificationApi = DOMAIN+"/notification/raiseNotification";
export const notificationsApi = DOMAIN+"/notification/notifications"
export const searchNotificationsApi = DOMAIN+"/notification/searchNotifications";
export const aiIntegrationApi = DOMAIN+"/aiIntegration/aiIntegration";

export const testGptApi = DOMAIN+"/aiIntegration/testGpt";
export const testGeminiApi = DOMAIN+"/aiIntegration/testGemini";

export const generateApi = DOMAIN+"/aiIntegration/generate";
export const firmListingsApi = DOMAIN+"/aiIntegration/firmListingsApi";
export const getGeminiResponseApi = DOMAIN+"/case/getGeminiResponse";
export const getFundersForCaseApi = DOMAIN+"/teamup/getFunders";
export const inviteFunderApi = DOMAIN+"/teamup/inviteFunder";
export const getTeamUpInvitesApi = DOMAIN+"/teamup/getTeamUpInvites";
export const removeInviteApi = DOMAIN+"/teamup/removeInvite";
export const getTeamUpInvitesReceivedApi = DOMAIN+"/teamup/getTeamUpInvitesReceived";
export const getConfirmedTeamUpsApi = DOMAIN+"/teamup/getConfirmedTeamUps";
export const updateInviteStatusApi = DOMAIN+"/teamup/updateInviteStatus";
export const getAttConfirmedTeamUpsApi = DOMAIN+"/teamup/getAttConfirmedTeamUps";

export const markAsReadApi = DOMAIN+"/notification/markAsRead"
export const clearApi = DOMAIN+"/notification/clear"
export const markAllAsReadApi = DOMAIN+"/notification/markAllAsRead"
export const sendEmailApi = DOMAIN+"/auth/sendMail"
export const contactUsApi = DOMAIN+"/auth/contactUs"
export const sendSigninConfirmCodeApi = DOMAIN+"/auth/sendSigninConfirmCode";
export const mailTriggersOnceADayApi = DOMAIN+"/auth/mailTriggersOnceADay";
export const sendChangeOrgCodeApi = DOMAIN+"/auth/sendChangeOrgCode";
export const verifyCodeApi = DOMAIN+"/auth/verifyCode";
export const getEmailPrefApi = DOMAIN+"/auth/getEmailPref"
export const setEmailPrefApi = DOMAIN+"/auth/setEmailPref"
export const getAdminIdApi = DOMAIN+"/auth/adminDet";
export const downloadAttachmentsApi = DOMAIN + '/download/downloadCaseZip';
export const generateSignedurlApi = DOMAIN + '/download/generateSignedurl/';
export const generateSignedurlForDocsApi = DOMAIN + '/download/generateSignedurlForDocs/';
export const denyUserApi = DOMAIN+"/account/denyUser/";
export const deleteUpdateOnProfAccApi = DOMAIN+"/account/deleteUpdateOnProfAcc/";
export const getProfessionalsImagesApi = DOMAIN+"/account/getProfessionalsImages";
export const deleteUserAsAdminApi = DOMAIN+"/auth/deleteUserAsAdmin";
export const isUserAvailableOnCognitoApi = DOMAIN+"/auth/isUserAvailableOnCognito";
export const getGAPageViewsApi = DOMAIN+"/analytics/getGAPageViews";

export const toApproveApi = DOMAIN+"/account/toApprove";
export const getUserDetailsToApproveApi = DOMAIN+"/account/getUserDetailsToApprove";

export const changePasswordApi = DOMAIN+"/account/changePassword";
export const signinApi = DOMAIN+'/auth/signin';
export const checkIfLoggedInApi = DOMAIN+'/auth/checkIfLoggedIn';
export const signUpApi = DOMAIN+'/auth/signup';
export const addUserApi = DOMAIN+'/auth/addUserAsAdmin';
export const createUserApi = DOMAIN+'/auth/createUser';
export const getAllAdminAssistantsApi = DOMAIN+'/auth/getAllAdminAssistants';
export const resetPasswordAsAdminApi = DOMAIN+'/auth/resetPasswordAsAdmin';
export const getExpirationTimeApi = DOMAIN+'/auth/getExpirationTime';


export const isEmailAvailableApi = DOMAIN+'/auth/isEmailAvailable';
export const getUserIdByEmailApi = DOMAIN+'/auth/getUserIdByEmail/';

export const createCaseApi = DOMAIN+'/case/createCase';
export const saveCaseDraftApi = DOMAIN+'/case/draft';
export const getCaseDraftApi = DOMAIN+'/case/draft';
export const clearCaseDraftApi = DOMAIN+'/case/draft/clear';
export const generateGeminiSummaryApi = DOMAIN+'/case/generateGeminiSummary';
// Fired independently of generateGeminiSummaryApi (research -> valuation) -
// not a retry, this is firm-match's own first-attempt call, so results can
// come back as soon as they're ready instead of waiting on the other chain.
export const firmMatchApi = DOMAIN + '/case/:caseId/firmMatch';
export const retryFirmMatchApi = DOMAIN + '/case/:caseId/retry/firmMatch';
export const retryValuationApi = DOMAIN + '/case/:caseId/retry/valuation';
export const retryPartyResearchApi = DOMAIN + '/case/:caseId/retry/partyResearch';
export const getCasesApi = DOMAIN+'/case/all';
export const getCaseDetailsApi = DOMAIN+'/case';
export const getCaseDetailsProfApi = DOMAIN+'/case/prof';
export const caseDetailsProfApi = DOMAIN+"/case/profCaseDetails";
export const searchWithCaseNumberApi = DOMAIN+"/case/searchWithCaseNumber";
export const markNotificationAsViewedApi = DOMAIN+"/case/markNotificationAsViewed";

export const updateCaseDetailsApi = DOMAIN+'/case/updateOptionalFields';
export const removeDocumentApi = DOMAIN+"/case/removeDoc";
export const updateDocumentsApi = DOMAIN+"/case/updateDocuments";
export const deleteCaseApi = DOMAIN+"/case/deleteCase";
export const casesStatusUpdateApi = DOMAIN+"/case/caseStatusUpdate";
export const caseRelRemoveApi = DOMAIN+"/case/caseRelRemove";


export const getOpenCasesApi = DOMAIN+"/case/openCases";
export const listCasesApi = DOMAIN+'/case/listCases/';
export const userListCasesApi = DOMAIN+'/case/userListCases/';
export const getRequestReviewCountApi = DOMAIN + '/case/getRequestReviewCount/';
export const getCaseCountApi = DOMAIN + '/case/getCaseCount/';
// per-option case counts for the filter popup (Type of case / states)
export const filterOptionCountsApi = DOMAIN + '/case/filterOptionCounts';
export const savedTeaserApi = DOMAIN + '/case/savedTeaser';
export const firmSavedPreviewApi = DOMAIN + '/case/firmSavedPreview';
export const firmOverviewApi = DOMAIN + '/case/firmOverview';
export const RequestPreviewApi = DOMAIN + '/case/requestPreview/';
export const getTeamupListApi = DOMAIN + '/case/getTeamupList';
export const teamupCountsApi = DOMAIN + '/case/teamupCounts/';
export const getReqClosedCasesCountApi = DOMAIN + '/case/getReqClosedCasesCount/';
export const getEmailSuggestionsApi = DOMAIN + "/account/getEmailSuggestions";
export const findUserWithEmailApi = DOMAIN + "/account/findUserWithEmail";
export const setStatusOfUserRelApi = DOMAIN + "/account/setStatusOfUserRel";
export const getRequestedListApi = DOMAIN + "/account/getRequestedList";
export const getRequestsListApi = DOMAIN + "/account/getRequestsList";
export const getApprovedAttorneysApi = DOMAIN + "/account/getApprovedAttorneys";
export const getAttorneyNotificationsApi = DOMAIN + "/account/getAttorneyNotifications";
export const deleteAllUsersApi = DOMAIN + "/account/deleteAllUsers";
export const getSubscriptionPriceApi = DOMAIN + "/account/getSubscriptionPrice";

export const saveFirmApi = DOMAIN + "/firm/saveFirm";
export const unsaveFirmApi = DOMAIN + "/firm/unsaveFirm";
export const clickedFirmApi = DOMAIN + "/firm/clickedFirm";
export const searchFirmApi = DOMAIN + "/firm/searchFirm";
export const getSavedFirmsApi = DOMAIN + "/firm/getSavedFirms";
export const checkIfFirmClaimedApi = DOMAIN + "/firm/checkIfFirmClaimed";
export const addNewFirmApi = DOMAIN + "/firm/addNewFirm";


export const searchSuggestionsApi = DOMAIN+"/case/searchSuggestions";






export const checkForConflictApi = DOMAIN+"/case/checkForConflict/";
export const getOwnerContactApi = DOMAIN+"/case/getOwnerContact/";


export const reqCasesApi = DOMAIN+"/case/reqCases";
export const approvedCasesApi = DOMAIN+"/case/approvedCases";
export const approveToViewApi = DOMAIN+"/case/approveToView";
export const denyToViewApi = DOMAIN+"/case/denyToView";
export const conflictToViewApi = DOMAIN+"/case/conflictToView";
export const noConflictToViewApi = DOMAIN+"/case/noConflictToView";
export const noConflictToViewComboApi = DOMAIN+"/case/noConflictToViewCombo";

export const noConflictNotInterestedToViewApi = DOMAIN+"/case/noConflictNotInterestedToView";
export const noConflictInterestedToViewApi = DOMAIN+"/case/noConflictInterestedToView";

export const noConflictCasesApi = DOMAIN+"/case/noConflictCases";
export const noConflictInterestedCasesApi = DOMAIN+"/case/noConflictInterestedCases";
export const isUserVerifiedApi = DOMAIN+"/account/isUserVerified"
export const getUserApprovalListApi = DOMAIN+"/account/getUserApprovalList";

export const closedCasesApi = DOMAIN+"/case/closedCases";
export const closeCaseApi = DOMAIN+"/case/closeCase";
export const denyToCloseApi = DOMAIN+"/case/denyToClose";

export const requestToCloseCasesApi = DOMAIN+"/case/requestToCloseCases";

export const requestToCloseApi = DOMAIN+"/case/requestToClose";
 


export const caseAnalyticsApi = DOMAIN+"/analytics/casesAnalytics";
export const statisticsApi = DOMAIN+"/analytics/statistics";
export const getCasesListApi = DOMAIN+"/analytics/getCasesList";
export const getProfessionalAnalyticsApi = DOMAIN+"/analytics/getProfessionalAnalytics";
export const getCasesListInMonthsApi = DOMAIN+"/analytics/getCasesListInMonths";
export const getCasesListInYearsApi = DOMAIN+"/analytics/getCasesListInYears";
export const getProfessionalListInMonthsApi = DOMAIN+"/analytics/getProfessionalListInMonths";
export const getProfessionalListInYearsApi = DOMAIN+"/analytics/getProfessionalsListInYears";
export const getClientAnalyticsApi = DOMAIN+"/analytics/getClientAnalytics";
export const getClientStatisticsApi = DOMAIN+"/analytics/getClientStatistics";

export const getClientListInMonthsApi = DOMAIN+"/analytics/getClientListInMonths";
export const getClientListInYearsApi = DOMAIN+"/analytics/getClientListInYears";
export const getAllProfessionalApi = DOMAIN+"/auth/getAllProfessional";
export const getLoginActivityApi = DOMAIN+"/auth/getLoginActivity";
export const getAllCaseDetailsApi = DOMAIN+"/auth/getAllCaseDetails";
export const getCaseDetApi = DOMAIN+"/case/getCaseDet"; 
export const reportCaseApi = DOMAIN+"/case/reportCase"; 
export const getReportsListApi = DOMAIN+"/analytics/getReportsList";


export const getAllCasesApi = DOMAIN+"/analytics/getAllCases";
// Admin > Firm outreach (server/routes/outreach.js)
export const outreachFirmsApi = DOMAIN + "/outreach/firms";
export const outreachCaseFirmsApi = DOMAIN + "/outreach/caseFirms";
export const outreachFirmEmailApi = DOMAIN + "/outreach/firmEmail";
export const outreachSendApi = DOMAIN + "/outreach/send";
export const outreachEmailCheckApi = DOMAIN + "/outreach/emailCheck";
export const outreachInviteApi = DOMAIN + "/outreach/invite/";   
export const getAnalyticsForProfessionalApi = DOMAIN+"/analytics/getAnalyticsForProfessional"; 


//subscription
export const getAllPrices = DOMAIN+"/subscription/subscription_prices";    
export const startSubsSession = DOMAIN+"/subscription/subscription_session";    
export const getSubscriptionData = DOMAIN+"/subscription/getSubscriptionData";    
export const cancelSubscription = DOMAIN+"/subscription/cancel_subscription";
export const createBillingPortalSessionApi = DOMAIN+"/subscription/createBillingPortalSession";
export const canSubscribeApi = DOMAIN+"/subscription/canSubscribe";

//preapproved
export const getAllSubscribedProfessionals = DOMAIN+"/preapprove/getAllSubscribedProfessionals";
export const preapprovedProfessionals = DOMAIN+"/preapprove/preapprovedProfessionals";
export const revertApprovalApi = DOMAIN+"/preapprove/revertApproval";


//S3 bucket urls
export const getSignedUrlApi = DOMAIN+"/case/getSignedUrl";
export const getDocumentDownloadUrlApi = DOMAIN+"/case/getDocumentDownloadUrl";

export const getAssistantReqApi = DOMAIN+"/auth/getAssistantReq";
export const getEmailSettingsApi = DOMAIN+"/auth/getEmailSettings";
export const getAdminAwaitCountApi = DOMAIN+"/auth/adminAwaitCounts";